import React from 'react';
import { componentService } from 'js/services/component.service';

export const ToastMessagePreferences = React.lazy(() => import(/* webpackChunkName: "toast-message-preferences" */ './ToastMessagePreferences'));

// <hub2-toast-message-preferences></hub2-toast-message-preferences>
componentService.registerWebContentComponents({ ToastMessagePreferences });
